// extracted by mini-css-extract-plugin
export default {"mainDiv":"sites_mainDiv__utCz9"};